import axios from '@/utils/request'

export default {
  getFileTaskList: data => axios({ url: '/api/admin/fileTaskList', method: 'POST', data }),//导入导出--列表
  fileTaskCancellationOrRetry: data => axios({ url: '/api/admin/fileTaskCancellationOrRetry', method: 'POST',  data }),//导入导出--取消/重试
  importExportFile: data => axios({ url: '/api/admin/importExportFile', method: 'POST',  data }),//新增导入导出任务
   
}